"use client"
import React from 'react';
import CenteredBox from '@/app/base-ui/CenterBox';
import ButtonChooseCustom from '@/app/base-ui/ButtonCustom';

interface ChooseGroupProps {
    onChange?: (checkboxes: boolean) => void;
    dataGroup: any;
    selected: string | number;
    setIsGroupSelected: (key: string) => void;
}

const ChooseGroup: React.FC<ChooseGroupProps> = ({ dataGroup, setIsGroupSelected, selected = 'all' }) => {
    return (
        <CenteredBox sx={{ flexDirection: 'column', gap: '10px', paddingTop: '30px' }}>
            <ButtonChooseCustom
                title={'기본'}
                onClick={() => setIsGroupSelected('all')}
                isSelected={selected === 'all'}
            />
            {dataGroup?.map((item: any, index: number) => {
                return (
                    <ButtonChooseCustom
                        key={index}
                        sx={{ py: '16px' }}
                        title={item.name}
                        onClick={() => setIsGroupSelected(item.id)}
                        isSelected={item.id === selected}
                    />
                );
            })}
        </CenteredBox>
    );
};

export default ChooseGroup;
